import {NgModule} from '@angular/core';
import {PageCommonModule} from '../page-common.module';
import {FormsModule} from '../../../components/forms/forms.module';
import {StepScreenComponent} from './step-screen.component';
import {RepeatableScreensManagerDeps} from './repeatable-screen-manager.class';
import {EntryWithSupportingDocument} from './accordion/entry.class';
import {VerificationModule} from '../../../components/verification/verification.module';
import {VerificationService} from '../../../components/verification/service/verification.service';

/**
 * Created by Rodrigo Quesada on 24/11/16.
 */
@NgModule({
    imports: [
        PageCommonModule,
        FormsModule,
        VerificationModule,
    ],
    declarations: [
        StepScreenComponent
    ],
    exports: [StepScreenComponent],
    providers: [
        RepeatableScreensManagerDeps,
        EntryWithSupportingDocument.InjectedMembers,
        VerificationService,
    ]
})
export class StepScreenModule {
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/@angularclass/hmr-loader!./~/tslint-loader!./src/app/pages/shared/step/step-screen.module.ts